<template>
    <div style="background: #E4E5E6">
        <Login v-if="!loggedIn" />

        <Layout v-if="loggedIn" />
    </div>
</template>
<script>
import Layout from './DefaultContainer'
import Login from './Login'

import { mapGetters } from 'vuex'
import { setTimeout } from 'timers'

export default {
    components: {
        Login,
        Layout,
    },
    created() {
        setTimeout(() => {
            this.$nextTick()
        }, 3000)
    },

    methods: {
        tokenAboutToExpire() {
            // console.log()
        },
    },
    computed: {
        ...mapGetters({
            loggedIn: 'auth/isAuthenticated',
            tokenExpiration: 'auth/tokenExpiration',
        }),
    },
    watch: {},
}
</script>
